import { AuthScreen } from "../auth/AuthScreen";
import { SystemState } from "../../shared/components/SystemState";
import { GeneralProductionModule } from "./GeneralProductionModule";
import { useGeneralProductionAccess } from "./useGeneralProductionAccess";

export function GeneralProductionPage() {
  const { state, retry } = useGeneralProductionAccess();
  if (state === "loading") return <SystemState mode="page" tone="loading"
    title="Genel üretim hazırlanıyor" description="Oturumunuz ve üretim raporu erişiminiz doğrulanıyor." />;
  if (state === "sign-in") return <AuthScreen />;
  if (state === "unavailable") return <AuthScreen mode="service-unavailable" onRetry={retry} />;
  if (state === "denied") return <SystemState mode="page" tone="warning"
    title="Bu modüle erişiminiz yok" description="Genel üretimi görmek için üretim raporu okuma yetkisi gerekir."
    primaryAction={{ label: "Erişimi yeniden kontrol et", onClick: retry }}
    secondaryAction={{ label: "Ana sayfaya dön", onClick: () => window.location.assign("/") }} />;
  return <GeneralProductionModule />;
}
